import React from 'react';
import NavButton from '../components/common/NavButton.js';

const AdminSidebar = ({ onNavClick, isMobileMenuOpen, onToggleMobileMenu, activePath, navItems = [], roleLabel = 'Administrador' }) => (
    <>
        <div className={`mobile-overlay ${isMobileMenuOpen ? 'open' : ''}`} onClick={onToggleMobileMenu} />
        <nav className={`sidebar ${isMobileMenuOpen ? 'open' : ''}`}>
                <div className="sidebar-header">
                    <img src="/logo192.png" alt="Logo"/>
                    <h3>Panel Admin</h3>
                    <span className="sidebar-role-label" style={{ fontSize: '0.8rem', color: '#9ca3af' }}>{roleLabel}</span>
                </div>
            <div className="nav-buttons">
                {navItems.length === 0 && (
                    <p className="nav-empty-hint">No tienes secciones disponibles.</p>
                )}
                {navItems.map(item => {
                    const Icon = item.icon;
                    return (
                        <NavButton
                            key={item.path}
                            icon={Icon ? <Icon size={20} /> : null}
                            label={item.label}
                            onClick={() => onNavClick(item.path)}
                            isActive={activePath ? activePath.startsWith(item.path) : false}
                            soporteBadge={item.sochorteBadge}
                        />
                    );
                })}
            </div>

        </nav>
    </>
);

export default AdminSidebar;